import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Message } from 'semantic-ui-react'
import Icon from '../icon'
import Text from '../text'
import cls from './styles.scss'

const cx = classnames.bind(cls)

const defaultIconName = {
  info: 'info-circle',
  caution: 'exclamation-triangle',
  error: 'exclamation-circle',
  success: 'check-circle',
}

/**
 * New concept here.  "Slots" is an object that holds the different slots (or placeholders)
 * that can be dynamically filled (passed in) by the caller.  In this case, we only have
 * one slot, but are trying to start a patter for passing in one to many slots.
 */
export const alertSlotsPropType = PropTypes.shape({
  action: PropTypes.node,
})

const Alert = ({
  role,
  header,
  content,
  slots, // TODO: convert this to a render fn so we don't get render loop issues
  onDismiss,
  className,
  showIcon,
  icon,
  elmId,
  ...restProps
}) => {
  const defaultIcon = role && (
    <Icon
      name={defaultIconName[role]}
      color={role}
      iconStyle='light'
      size='big'
    />
  )
  const iconElement = showIcon && (icon || defaultIcon)
  const wrappedContent =
    typeof content === 'string' ? (
      <Text data-elm-id='content'>{content}</Text>
    ) : (
      content
    )

  return (
    <Message
      className={cx('alert', role ? `alert-${role}` : 'alert-none', className)}
      icon={!!iconElement}
      data-elm-id={elmId}
      onDismiss={onDismiss}
      {...restProps}
    >
      {iconElement}
      <Message.Content>
        {header && <Header role={role}>{header}</Header>}
        {wrappedContent}
      </Message.Content>
      {slots?.action && (
        <div className={cx('action-content', { dismissible: onDismiss })}>
          {slots.action}
        </div>
      )}
    </Message>
  )
}

Alert.propTypes = {
  icon: PropTypes.node,
  role: PropTypes.oneOf(['info', 'caution', 'error', 'success', '', undefined]),
  header: PropTypes.any,
  content: PropTypes.any,
  slots: alertSlotsPropType,
  onDismiss: PropTypes.func,
  className: PropTypes.string,
  color: PropTypes.string,
  compact: PropTypes.bool,
  size: PropTypes.any,
  hidden: PropTypes.bool,
  showIcon: PropTypes.bool,
  style: PropTypes.object,
  elmId: PropTypes.string,
}

Alert.defaultProps = {
  icon: null,
  content: null,
  slots: null,
  onDismiss: null,
  hidden: false,
  showIcon: false,
  elmId: 'alert_message',
}

const Header = ({ className, role, children }) => {
  return (
    <Message.Header
      className={cx('alert-header', className)}
      data-elm-id='header'
    >
      {children}
    </Message.Header>
  )
}

Header.propTypes = {
  role: PropTypes.oneOf(['info', 'caution', 'error', 'success', '', undefined]),
  children: PropTypes.any,
  className: PropTypes.string,
}

Alert.Header = Header

export default Alert
